<template>
    <div id="ProjectViewInvitesupplierList">
        <eb-panel>
            <eb-panel-header class="panel-header" slot="header">
                <span slot="title">2 采购范围</span>
            </eb-panel-header>
            <div slot="body">
                <div class="panel-body-row">
                    <div class="panel-body-row-left">采购范围</div>
                    <div class="panel-body-row-right">{{project.buyScope| buyScope}}</div>
                </div>
                 <ebHandsontableView :hotSettings="hotSettings"/>
                <div class="mySupplierFooter">
                    <span class="totleLeft">已邀请
                        <span class="totleNumber">{{previewSupplier.supTotalCount}}</span>个供应商参与</span>
                    <span>(其中
                        <span class="totleNumber">{{previewSupplier.mySupCount}}</span>个为我的供应商)
                    </span>
                </div>
            </div>
        </eb-panel>
    </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebHandsontableView from '@/components/common/eb-handsontable-view';
export default {
  name: 'ProjectViewInvitesupplierList',
  props: {
    project: {
      required: true
    },
    previewSupplier: {
      required: true
    }
  },
  components: {
    ebPanel,
    ebPanelHeader,
    ebHandsontableView
  },
  watch: {
    previewSupplier: function(newVal) {
      if (newVal['supplierList']) {
        newVal['supplierList'].map((element, index, self) => {
          if (element['authStatus'] && element['authStatus'] === '1') {
            element['authStatus'] = '<span class="eb-font-type">实</span>';
          } else if (element['authStatus'] && element['authStatus'] !== '1') {
            element['authStatus'] = '';
          }
          if (element['companyLevel']) {
            element['companyLevel'] = this.$options.filters['companyLevel'](element['companyLevel']);
          }
        });
        this.hotSettings.data = newVal['supplierList'];
      }
    }
  },
  data() {
    return {
      hotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['供应商名称', '实名', '级别', '注册资本', '注册地址', '合作'],
        allowInsertRow: false,
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'departName',
            type: 'text',
            width: 280,
            readOnly: true,
            className: 'htCenter'
          },

          {
            data: 'authStatus',
            renderer: 'html',
            width: 70,
            readOnly: true,
            className: 'htCenter'
          },
          {
            data: 'companyLevel',
            type: 'text',
            width: 70,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'registerCapital',
            width: 210,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'companyAddress',
            width: 260,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'cooperationTimes',
            width: 60,
            className: 'htCenter',
            readOnly: true
          }
        ]
      }
    };
  },
  created() {
    this.$emit('onSupplierListCreated');
  }
};
</script>
<style scoped lang="less">
.mySupplierFooter {
  padding-top: 20px;
  .totleLeft{
      padding-right:30px;
  }
  .totleNumber {
    color: red;
  }
}
</style>
